var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "34px",
    viewBox: "0 0 41 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1317.000000, -2581.000000)",
    stroke: "#000000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1316.000000, 2579.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.4829035,6.27235081 L6.65813413,32.0971202",
    id: "Path-3",
    transform: "translate(19.850806, 19.676015) rotate(-315.000000) translate(-19.850806, -19.676015) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4-Copy",
    transform: "translate(24.347826, 19.130435) rotate(-315.000000) translate(-24.347826, -19.130435) ",
    points: "13.8949432 8.67755193 34.8007089 8.67755193 34.8007089 29.5833176"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.98e918cb9391a26c2e27a00409655ef2.svg";
export { ForwardRef as ReactComponent };